<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-inside: avoid;text-align: center;margin: 0;">
<a href="https://earlybirdbooks.com/freebook/index.html?q=636ec9453f47275110860a1b&amp;utm_campaign=front" target="_blank">
<img alt="image" src="love.jpg" style="max-width:100%;max-height:100%;"/></a>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// love_1.vue?7972ea2c